import { MOD_FLT_LOD, MOD_REFR } from './keys';

const initialState = { filterLoader: true, refreshPost: false }

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case MOD_FLT_LOD: {
            return { ...state, filterLoader: action.payload }
        }
        case MOD_REFR: {
            return { ...state, refreshPost: action.payload }
        }
        default:
            return { ...state }
    }

}